import { ContextService } from '../context-service';
import { SearchParams } from '@apply4u/models/search/search-params';
import { ResultsWithOutPagination } from '@apply4u/models/search/results-with-out-pagination';
import { Injectable } from '@angular/core';
import { environment } from '@environment/environment';
import { HttpClientWrapper } from '../httpclientwrapper';
import { JobStatistics } from '@apply4u/models/jobStatistics';
import { Observable } from 'rxjs';
import { IsNotNull, IsNotNullOrEmpty, IsNotZero, IsNotZeroNumber, IsNullOrEmpty, IsTrue, IsZero } from '@apply4u/shared/helpers/common/type-safe-helpers';
import { Job } from '@apply4u/models/search/job';
import { FormatSeoUrl } from '@apply4u/shared/helpers/seo-helper';
import { Recommendation } from '@apply4u/models/search/recommendation';
import { ManageJobDetail } from '@apply4u/models/search/manage-job-detail';
import { SimilarJob } from '@apply4u/models/similar-job/similar-job';
import { SearchDurationConst} from '@apply4u/shared/constant/search-within/search-duration-const';

@Injectable({
  providedIn: 'root'
})
export class JobSearchService {
  BaseUrl: string = environment.BaseUrl;
  SearchHash : string;

  constructor(private http: HttpClientWrapper,
    private contextService: ContextService) {
  }

  SaveJobStatistics(JobStatisticsObj: JobStatistics): Observable<JobStatistics> {
    return this.http.PostAsync<JobStatistics>(this.http.BaseUrl + "api/Jobs/JobStatistics", JobStatisticsObj);
  }

  GetNewJob(id, searchHash): Observable<Job> {
    let queryString = "?";

    if (this.contextService.IsUserLoggedIn) {
      queryString += "UserId=" + this.contextService.LoggedInUserId;
    }

    if (IsNotNullOrEmpty(searchHash)) {
      queryString += (queryString == "?" ? "" : "&") + "SearchHash=" + searchHash;
    }

    if (IsNotNullOrEmpty(queryString) && queryString.length == 1 && queryString == "?") {
      queryString = "";
    }

    return this.http.GetAsync<Job>(this.BaseUrl + "api/Jobs/new/" + id + queryString);
  }

  JobSearchNew(searchParams: SearchParams): Observable<ResultsWithOutPagination<Job>> {
    return this.http.GetAsync<ResultsWithOutPagination<Job>>(this.http.BaseUrl + "api/search/new/jobs" + this.PrepareQueryString(searchParams));
  }
  
  GetRecommendedJobs(userId: number, isRecruiter: boolean, pageNumber: number, pageSize: number): Observable<Recommendation<Job>> {
    return this.http.GetAsync<Recommendation<Job>>(`${this.http.BaseUrl}api/search/GetRecommendedJobs?userId=${userId}&isRecruiter=${isRecruiter}&pageNumber=${pageNumber}&pageSize=${pageSize}`);
  }

  PrepareQueryString(searchParams: SearchParams): string {
    let queryParams = "";
    let isDefault = true;
    if (IsNotNullOrEmpty(searchParams.Keywords)) {
      queryParams += "&keywords=" + encodeURIComponent(searchParams.Keywords);
      isDefault = false;
    }

    if (IsNotNullOrEmpty(searchParams.Location)) {
      queryParams += "&location=" + encodeURIComponent(searchParams.Location);
      isDefault = false;
    }

    if (IsNotZero(searchParams.Latitude)) {
      queryParams += (queryParams == "?" ? "" : "&") + "latitude=" + searchParams.Latitude;
      isDefault = false;
    }

    if (IsNotZero(searchParams.Longitude)) {
      queryParams += (queryParams == "?" ? "" : "&") + "longitude=" + searchParams.Longitude;
      isDefault = false;
    }

    if (IsNotZero(searchParams.Radius)) {
      queryParams += "&radius=" + searchParams.Radius;
      isDefault = false;
    }

    if (IsNotNullOrEmpty(searchParams.SectorIds)) {
      queryParams += "&sectorids=" + searchParams.SectorIds;
      isDefault = false;
    }


    if (IsNotNullOrEmpty(searchParams.JobTypes)) {
      queryParams += "&jobTypes=" + searchParams.JobTypes;
      isDefault = false;
    }

    if (IsNotNullOrEmpty(searchParams.JobStatus) && searchParams.JobStatus != "500") {
      queryParams += "&jobStatus=" + searchParams.JobStatus;
      isDefault = false;
    }

    if (IsNotZero(searchParams.SalaryFrom)) {
      queryParams += "&salaryFrom=" + searchParams.SalaryFrom;
      isDefault = false;
    }

    if (IsNotZero(searchParams.SalaryTo)) {
      queryParams += "&salaryTo=" + searchParams.SalaryTo;
      isDefault = false;
    }

    if (IsNotNull(searchParams.IncludeUnspecifiedSalaries) && searchParams.IncludeUnspecifiedSalaries==true) {
      queryParams += (queryParams == "?" ? "" : "&") + "includeUnspecifiedSalaries=" + searchParams.IncludeUnspecifiedSalaries;         
    }
    
    if (IsNotZero(searchParams.SalaryDuration)) {
      queryParams += "&salaryDuration=" + searchParams.SalaryDuration;
      isDefault = false;
    }

   // Commented this part of code to meet the requirement of Advance search new flow Please don't uncomment it OR discuss it with AD Sir
    // if (IsNotNullOrEmpty(searchParams.AllofTheseWords)) {
    //   if (searchParams.AllofTheseWords.match(/^[0-9]+$/g)) // check string has integer
    //   {
    //     if (searchParams.AllofTheseWords.match(/^0+/g)[0].length > 0) // count total zero instart
    //     {
    //       searchParams.AllofTheseWords = searchParams.AllofTheseWords.slice(searchParams.Keywords.match(/^0+/g)[0].length);
    //     }
    //   }

    //   if (IsNotNullOrEmpty(searchParams.AllofTheseWords)) {
    //     queryParams += "&allofTheseWords=" + encodeURIComponent(searchParams.AllofTheseWords);
    //   }
    // }

    // if (IsNotNullOrEmpty(searchParams.ExactPhrae)) {
    //   queryParams += "&exactPhrae=" + encodeURIComponent(searchParams.ExactPhrae);
    // }

    // if (IsNotNullOrEmpty(searchParams.AnyOfTheseWords)) {
    //   queryParams += "&anyOfTheseWords=" + encodeURIComponent(searchParams.AnyOfTheseWords);
    // }

    // if (IsNotNullOrEmpty(searchParams.NoneOfTheseWords)) {
    //   queryParams += "&noneOfTheseWords=" + encodeURIComponent(searchParams.NoneOfTheseWords);
    // }

    if (IsTrue(searchParams.IsBooleanSearch)) {
      queryParams += "&isBooleanSearch=" + searchParams.IsBooleanSearch;
      isDefault = false;
    }

    if (IsNotNullOrEmpty(searchParams.SearchTextForBoolean)) {
      queryParams += "&searchTextForBoolean=" + encodeURIComponent(searchParams.SearchTextForBoolean);
      isDefault = false;
    }

    if(!!searchParams && IsNotNull(searchParams.SearchWithIn)){
      isDefault = false;
      if (searchParams.SearchWithIn != 0 && searchParams.SearchWithIn != -1) {
        queryParams += "&searchWithInLast=" + searchParams.SearchWithIn;
      }else {
        queryParams += "&searchWithInLast=30";
      }
    }


    if(isDefault){
      searchParams.SearchWithIn = SearchDurationConst.LastTwoWeeks;
      queryParams += `&searchWithInLast=${SearchDurationConst.LastTwoWeeks}`;
    }

    if (IsTrue(searchParams.UseSteming)) {
      queryParams += "&useSteming=" + searchParams.UseSteming;
    }

    if (IsNotNullOrEmpty(searchParams.SearchInJobTitle)) {
      queryParams += "&searchInJobTitle=" + searchParams.SearchInJobTitle;
    }

    if (IsNotZero(searchParams.SeoContentFor)) {
      queryParams += "&seoContentForId=" + searchParams.SeoContentFor;
    }

    if (IsNotNullOrEmpty(searchParams.SortBy)) {
      queryParams += "&sortBy=" + searchParams.SortBy;
    }

    if (IsNotZero(searchParams.PageNumber)) {
      queryParams += "&pageNumber=" + searchParams.PageNumber;
    }

    if (IsNotZero(searchParams.PageSize)) {
      queryParams += "&pageSize=" + searchParams.PageSize;
    }

    if (this.contextService.IsUserLoggedIn) {
      queryParams += "&UserId=" + this.contextService.LoggedInUserId;
    }

    if (IsNotNullOrEmpty(queryParams)) {
      if (queryParams.startsWith("&") && queryParams.length > 1) {
        queryParams = "?" + queryParams.substring(1);
      }
    }

    return queryParams;
  }

  GetLocationByLatLong(latitude: number, longitude: number): Observable<string> {
    let requesPramas = "?";

    if (latitude !== undefined && latitude != null) {
      requesPramas += "latitude=" + latitude;
    }

    if (longitude !== undefined && longitude != null) {
      requesPramas += (requesPramas == "?" ? "" : "&") + "longitude=" + longitude;
    }

    return this.http.GetAsync<string>(this.http.BaseUrl + "/api/Location/coordinates" + requesPramas);
  }

  ReportMisUse(userId: any, JobId: any) {
    return this.http.PutAsync(this.http.BaseUrl + "api/Jobs/reportmisuse/notification?jobId=" + JobId + "&loggedInUserId=" + userId, null);
  }

  GetManageJobDetail(jobId:number): Observable<ManageJobDetail> {
    let queryString = "?";

    if (this.contextService.IsUserLoggedIn) {
      queryString += "userId=" + this.contextService.LoggedInUserId;
    }

    return this.http.GetAsync<ManageJobDetail>(this.BaseUrl + "api/Jobs/managejob/" + jobId + queryString);
  }

  GetSimilarJobsAsync(keywords: string, locationText: string, pageNumber: number, pageSize: number): Observable<ResultsWithOutPagination<SimilarJob>> {
    let requesPramas = "?";

    if (IsNotNullOrEmpty(keywords)) {
      requesPramas += "keywords=" + keywords;
    }

    if (IsNotNullOrEmpty(locationText)) {
      requesPramas += (requesPramas == "?" ? "" : "&") + "locationText=" + locationText;
    }

    if (IsNotZeroNumber(pageNumber)) {
      requesPramas += (requesPramas == "?" ? "" : "&") + "pageNumber=" + pageNumber;
    }

    if (IsNotZeroNumber(pageSize)) {
      requesPramas += (requesPramas == "?" ? "" : "&") + "pageSize=" + pageSize;
    }

    return this.http.GetAsync<ResultsWithOutPagination<SimilarJob>>(this.http.BaseUrl + "api/search/similarJobs" + requesPramas);
  }

  FeaturedJobs(Id:number): Observable<Job[]> {
    return this.http.GetAsync<Job[]>(this.http.BaseUrl + "api/jobs/featuredjobs?Id=" + Id);
  }

  RecentJobs(): Observable<Job[]> {
    return this.http.GetAsync<Job[]>(this.http.BaseUrl + "api/jobs/recentjobs");
  }
}
